/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Modeling UI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextIcon from './TextIcon';

export default class EmptyState extends Component<any, any> {
	static propTypes = {
		icon: PropTypes.object,
		iconSize: PropTypes.number,
		header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
		button: PropTypes.node,
		height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	};

	static defaultProps = {
		iconSize: 128,
		height: '100%',
		maxWidth: 300,
	};

	render() {
		const { icon, iconSize, header, body, button, height, maxWidth } = this.props;
		const headerMarginTop = icon ? 3 : 0;
		const bodyMarginTop = header ? 1 : headerMarginTop;
		const buttonMarginTop = icon || header || body ? 3 : 0;

		return (
			<TextIcon height={height} justifyContent="center">
				{icon && <TextIcon.Icon icon={icon} height={iconSize} width={iconSize} />}
				{header && (
					<TextIcon.Header maxWidth={maxWidth} gutter={[headerMarginTop, 0, 0, 0]}>
						{header}
					</TextIcon.Header>
				)}
				{body && (
					<TextIcon.Body maxWidth={maxWidth} gutter={[bodyMarginTop, 0, 0, 0]}>
						{body}
					</TextIcon.Body>
				)}
				{button && (
					<TextIcon.Body maxWidth={maxWidth} gutter={[buttonMarginTop, 0, 0, 0]}>
						{button}
					</TextIcon.Body>
				)}
			</TextIcon>
		);
	}
}
